export function stepIteration(start: number, end: number, step: number): number[]
export function stepIteration<T>(start: number, end: number, step: number, handler: (value: number) => T): T[]
export function stepIteration<T>(start: number, end: number, step: number, handler?: (value: number) => T) {
  const res: (number | T)[] = []
  for (let value = start; value <= end; value += step) {
    res.push(handler ? handler(value) : value)
  }
  return res
}
